import React, { Component } from 'react'
import type { Crop, Canvas } from '../types'
import { polyfillToBlob } from '../helpers'

type Props = {
  display: ?boolean,
  radius: ?number,
  src: string,
  crop: ?Crop,
  width: number,
  height: number,
  onData: (blob: string) => void,
}

type State = {
  loaded: boolean,
  image: ?Image,
  crop: Object,
}

export class ImageAsBlob extends Component {
  props: Props
  state: State
  canvas: ?Canvas

  constructor(props: Props) {
    super(props)
    this.state = {
      loaded: false,
      image: null,
      crop: {
        x: null,
        y: null,
      },
    }
  }

  componentWillReceiveProps(newProps: Props) {
    if (newProps.src !== this.props.src) {
      this.setState({ image: null, loaded: false })
      this.loadImage(newProps.src)
    } else {
      this.createBlob(newProps)
    }
  }

  componentDidMount() {
    this.loadImage(this.props.src)
  }

  createBlob(props: Props) {
    const { image, crop: cropState } = this.state
    const { crop, width, height } = props
    const { canvas } = this

    const isTheSameCoords = crop.x === cropState.x && crop.y === cropState.y
    const isTheSameDimensions =
      crop.height === cropState.height || crop.width === cropState.width

    if (!image || !canvas || (isTheSameCoords && isTheSameDimensions)) return

    const imageWidth = image.naturalWidth
    const imageHeight = image.naturalHeight

    const cropX = (crop.x / 100) * imageWidth
    const cropY = (crop.y / 100) * imageHeight

    const cropWidth = (crop.width / 100) * imageWidth
    const cropHeight = (crop.height / 100) * imageHeight

    canvas.width = width
    canvas.height = height

    const ctx = canvas.getContext('2d')

    ctx.drawImage(
      image,
      cropX,
      cropY,
      cropWidth,
      cropHeight,
      0,
      0,
      width,
      height
    )

    // Safari does not support toBlob()
    polyfillToBlob()

    canvas.toBlob(blob => {
      const { onData, crop } = this.props
      if (onData) {
        onData(blob)
      }

      this.setState({ crop })
    })
  }

  render() {
    const { loaded } = this.state
    const { display, radius = 0 } = this.props
    if (!loaded) {
      return <div>Loading...</div>
    }

    return (
      <canvas
        ref={canvas => (this.canvas = canvas)}
        style={{
          borderRadius: radius ? `${radius} ${radius}` : null,
          display: display ? null : 'none',
        }}
      />
    )
  }

  loadImage(src: string) {
    let image = new Image()
    image.onload = () => {
      this.setState({ image, loaded: true }, () => this.createBlob(this.props))
    }
    image.src = src
  }
}



// WEBPACK FOOTER //
// ./src/components/ImageAsBlob.js